import type { AxiosRequestConfig } from 'axios'
import qs from 'qs'

import { SPANISH_SUBDIRECTORY } from '../../constants/api'
import { isApi2 } from './isApi2'
import { isApi3 } from './isApi3'

const DEBUG_TYPE_HOSTS: Record<string, string | undefined> = {
  play_game_websocket2: import.meta.env.VITE_DEBUG_PLAY_GAME_WS_URL,
}

function extractRequestType(
  requestConfig: AxiosRequestConfig,
): string | undefined {
  const data: unknown = requestConfig.data
  if (data instanceof FormData) {
    const t = data.get('type')
    return typeof t === 'string' ? t : undefined
  }
  if (typeof data === 'string') {
    const parsed = qs.parse(data).type
    return typeof parsed === 'string' ? parsed : undefined
  }
  return undefined
}

export function getApiOrigin(axiosRequestConfig: AxiosRequestConfig) {
  const subdirectory = SPANISH_SUBDIRECTORY

  const type = extractRequestType(axiosRequestConfig)
  const debugHost = type ? DEBUG_TYPE_HOSTS[type] : undefined
  if (debugHost) {
    return `${debugHost}${subdirectory}`
  }

  let domain = import.meta.env.VITE_API_URL
  // VITE_API_URL_3 is optional: when unset, v3 requests fall back to VITE_API_URL
  // and the backend nginx reverse-proxies them to the Java service.
  if (isApi3(axiosRequestConfig))
    domain = import.meta.env.VITE_API_URL_3 || import.meta.env.VITE_API_URL
  else if (isApi2(axiosRequestConfig))
    domain = import.meta.env.VITE_API_URL_2 || import.meta.env.VITE_API_URL

  return `${domain}${subdirectory}`
}
